// extracted by mini-css-extract-plugin
export default {"addEquipmentButton":"SurveyView_addEquipmentButton__ZO1FN","surveyItemWitMargin":"SurveyView_surveyItemWitMargin__eLIdo"};